{
  "dss": {
    "button": {
      "back": "Geri",
      "cancel": "İptal",
      "close": "Kapat",
      "confirmDelete": "Evet, sil",
      "continue": "Devam et",
      "logout": "Oturumu kapat",
      "passwordReset": "Şifre Sıfırlama",
      "save": "Kaydet",
      "verify": "Doğrula"
    },
    "error": {
      "403": "Bu sayfaya erişiminiz yok.",
      "404": "Bu sayfa mevcut değil.",
      "generic": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      "invalidConfirmationLink": "Doğrulama bağlantısının süresi doldu veya geçersiz.",
      "throttling": "Çok fazla deneme. Bu işlem bir süreliğine engellendi.",
      "title": "Hata",
      "title403": "Erişim reddedildi",
      "title404": "Bulunamadı"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "SADAL Tarım Makineleri Dış Tic. A.Ş. Tüm hakları saklıdır.",
      "privacy": "Gizlilik Politikası",
      "terms": "Şartlar ve Koşullar"
    },
    "label": {
      "CRMAccountNumber": "CRM Hesap Numarası",
      "contact": "İletişim",
      "email": "E-posta",
      "faq": "SSS",
      "female": "Bayan",
      "firstname": "Ad",
      "help": "Yardım",
      "language": "Dil",
      "lastname": "Soyad",
      "male": "Bay",
      "needHelp": "Yardıma mı ihtiyacınız var?",
      "newPassword": "Yeni şifre",
      "newPassword2": "Yeni şifreyi doğrula",
      "oldPassword": "Mevcut şifre",
      "organization": "Organizasyon",
      "password": "Şifre",
      "required": "gerekli",
      "salutation": "Hitap",
      "select": "Lütfen seçin"
    },
    "lang": {
      "de": "Almanca"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Kaydı Doğrulayın",
        "wait": "Hesap doğrulamasının tamamlanması için lütfen bekleyin."
      },
      "otp": {
        "btnResend": "Doğrulama kodu e-postasını yeniden gönder",
        "msg": {
          "invalidOTP": "Girilen tek kullanımlık şifre geçersiz.",
          "resendFail": "Kod yeniden gönderilemedi. Lütfen daha sonra tekrar deneyin."
        },
        "spamDetail": "Gelen kutunuzu ve spam klasörünüzü STIHL Support (noreply{'@'}stihl-sso.com) e-postası için kontrol edin",
        "spamTitle": "E-posta gelmedi mi?",
        "subtitle": "Devam etmek için e-posta adresinizi doğrulamanız gerekiyor.",
        "title": "Kullanıcı hesabınızı doğrulayın",
        "txtVerifyMail": "Lütfen {email} e-posta adresinize gönderdiğimiz yeni doğrulama kodunu girin"
      },
      "personal": {
        "msg": {
          "noChange": "Güncellenecek bir şey yok.",
          "updateError": "Kişisel veriler güncellenemedi.",
          "updated": "Kişisel veriler güncellendi.",
          "userLoadErr": "Kullanıcı verileri yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin."
        },
        "secOrganization": "Organizasyon",
        "secPersonal": "Kişisel",
        "secSettings": "Tercih Edilen Ayarlar",
        "title": "Kişisel Bilgiler"
      },
      "postPwSet": {
        "info": "Artık yeni şifrenizi kullanabilirsiniz.",
        "link_name": "Self-Service'e devam et",
        "link_url": "/user/ui/",
        "title": "Şifreniz değiştirildi"
      },
      "resetPW": {
        "title": "Şifrenizi sıfırlayın"
      },
      "security": {
        "2fa": {
          "availableMethods": "Mevcut 2FA yöntemleri:",
          "info": "İki faktörlü kimlik doğrulama (2FA), hesabınıza ek bir koruma katmanı ekleyen bir güvenlik özelliğidir. Yalnızca kullanıcı adı ve şifre yerine giriş için iki yöntem kullanmanızı gerektirir.",
          "method": {
            "email": "E-posta",
            "emailDesc": "Kimlik doğrulama isteklerini tamamlamak için e-posta ile tek kullanımlık kodlar alın.",
            "oath": {
              "add": {
                "button": "Authenticator uygulamasını kaydet"
              }
            }
          }
        },
        "authenticator": "Authenticator uygulaması",
        "infoFederatedAccount": "Bu hesap, kuruluşunuzun kimlik sağlayıcısı tarafından yönetilmektedir, bu nedenle şifre burada değiştirilemez. Şifrenizi değiştirmek için kuruluşunuzun giriş sayfası üzerinden oturum açın veya BT yöneticinizle iletişime geçin.",
        "lastUse": "Son kullanım: {0}",
        "msg": {
          "invalidPassword": "Geçersiz mevcut şifre girildi.",
          "passwordAlreadyUsed": "Son 5 şifre yeniden kullanılamaz.",
          "pwUpdateError": "Şifre değiştirilmeye çalışılırken bir hata oluştu.",
          "pwUpdated": "Şifre değiştirildi."
        },
        "noDevice": "Yapılandırılmadı",
        "oathAdd": {
          "appInfo": "STIHL girişini kolaylaştırmak için {0}, {1}, {2} gibi Authenticator uygulamalarını kullanarak giriş sırasında ikinci faktör olarak kullanılan tek kullanımlık şifreler oluşturabilirsiniz.<br/>Mobil cihazınızı kaybettiyseniz veya unuttuysanız, e-posta ile gönderilen 2FA kodunu her zaman kullanabilirsiniz.<br/><br/>Lütfen kimlik doğrulama cihazınızı kurmak için aşağıdaki talimatları izleyin.",
          "badCode": "Geçersiz kod, lütfen tekrar deneyin.",
          "error": "Kimlik doğrulama cihazı kaydedilirken bir hata oluştu.",
          "headScan": "1. Authenticator uygulamanızla QR kodunu tarayın",
          "headVerify": "2. Kodu doğrulayın",
          "infoKey": "kurulum anahtarı",
          "infoKeyTitle": "İki faktörlü sırrınız",
          "infoScanBottom": "Taramıyor musunuz? Authenticator uygulamanızı manuel olarak yapılandırmak için {0} kullanabilirsiniz.",
          "infoVerify": "Authenticator uygulamanız tarafından oluşturulan kodu girin.",
          "success": "Kimlik doğrulama cihazınız kaydedildi. Artık giriş için kullanabilirsiniz.",
          "title": "İki Faktörlü Kimlik Doğrulama cihazınızı kaydedin"
        },
        "oathDelete": {
          "error": "Kimlik doğrulama cihazı silinirken bir hata oluştu.",
          "success": "Kimlik doğrulama cihazı silindi."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey, kontrolünüz altındaki bir doğrulayıcı tarafından saklanan kriptografik anahtar çiftleridir (açık anahtar ve özel anahtar). Doğrulayıcı, kullanıcının hazır olduğunu ve passkey'i kullanmaya yetkili olduğunu kanıtlayabilir. Doğrulayıcılar, yetkilendirmeyi yetenek ve yapılandırmalarına bağlı olarak PIN, kod, biyometri veya cihaz şifresi ile kanıtlar. Doğrulayıcılar; iPhone veya Android cihaz, Windows Hello, FIDO2 donanım güvenlik anahtarı veya bir parola yöneticisi gibi birçok biçimde olabilir.",
            "info2": "STIHL'a bir passkey ile giriş yaptığınızda doğrulayıcınız, passkey'i asla göndermeden kimliğinizi STIHL'a kanıtlamak için açık anahtar kriptografisi kullanır. Passkey'ler stihl-sso.com gibi bir web sitesi alanına bağlıdır ve güvenli bir bağlantı gerektirir; bu, tarayıcının benzer bir oltalama sitesinde kimlik doğrulamayı reddedeceği anlamına gelir. Bu özellikler, passkey'leri oltalamaya karşı oldukça dayanıklı ve SMS veya TOTP 2FA'ya göre saldırması çok daha zor hale getirir.",
            "info3": "Bulut destekli passkey hizmetleri, passkey'lerin cihazlar arasında (ör. Apple cihazları, Android cihazları veya parola yöneticileri) senkronize edilmesini sağlar; böylece daha çok yerde kullanılabilir ve kaybolmaları daha zordur. Bir cihazda senkronize bir passkey kurduğunuzda, aynı hizmeti kullanan birden fazla cihazda kullanılabilir hale gelir. Örneğin, MacBook'unuzdaki Touch ID ile iCloud hesabınıza bir passkey kaydederseniz, daha sonra aynı iCloud hesabına bağlı birden fazla cihazda yüz, parmak izi, PIN veya cihaz şifresi ile bu passkey'i kullanabilirsiniz.",
            "title": "Passkey'ler Hakkında"
          },
          "add": {
            "button": "Yeni Passkey ekle",
            "error": "Yeni passkey eklenirken bir hata oluştu.",
            "success": "Yeni bir passkey eklendi."
          },
          "delete": {
            "button": "Passkey'i sil",
            "error": "Bu passkey silinirken bir hata oluştu.",
            "success": "Passkey silindi."
          },
          "edit": {
            "error": "Passkey adı kaydedilirken bir hata oluştu.",
            "name": "Passkey Adı",
            "success": "Passkey adı güncellendi.",
            "title": "Diğer passkey'lerden ayırt etmek için Passkey'inize bir ad verin"
          },
          "info": "Passkey, kimliğinizi dokunma, yüz tanıma, cihaz şifresi veya PIN ile doğrulayan, şifrelere basit ve güvenli bir alternatiftir.",
          "none": "Yapılandırılmış passkey yok.",
          "reallyDelete": "Passkey'i silmek istediğinizden emin misiniz?",
          "registeredPasskeys": "Kayıtlı Passkey'leriniz:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Kimlik doğrulama cihazını silmek istediğinizden emin misiniz?",
        "secMFA": "İki Faktörlü Kimlik Doğrulama",
        "secPwdChange": "Şifreyi değiştir",
        "title": "Güvenlik"
      },
      "setPW": {
        "acceptTC": "Lütfen {terms} şartlarımızı onaylayın ve {privacy} metnimizi okuyun.",
        "killSSO": "Tüm aktif oturumları geçersiz kıl",
        "msg": {
          "tokenExpired": "Şifre bağlantısının veya kodunun süresi doldu. Lütfen şifrenizi sıfırlamak için bağlantıyı izleyin: {link}."
        },
        "privacy": "Veri Gizliliği Politikası",
        "terms": "Şartlar ve Koşullar",
        "title": "Yeni şifre girin"
      }
    },
    "validations": {
      "hasDigit": "Rakam içermeli",
      "hasLowercase": "Küçük harf içermeli",
      "hasSpecial": "Özel karakter içermeli: {chars}",
      "hasUppercase": "Büyük harf içermeli",
      "invalidCharacters": "Geçersiz karakterler içeriyor",
      "maxLength": "En fazla {max} karaktere izin verilir",
      "minLength": "En az {min} karakter olmalı",
      "notSameAsEmail": "E-posta adresine çok benzer",
      "onlyValidCharactersAllowed": "Sadece harf, rakam ve boşluklara izin verilir.",
      "required": "Gerekli alan",
      "sameAsPassword": "Şifreler eşleşmiyor",
      "tcAccepted": "Lütfen şartlar ve koşullarımızı onaylayın.",
      "validEmail": "Geçersiz e-posta adresi.",
      "validOTP": "Lütfen doğrulama kodunu girin."
    }
  }
}
